; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/Picture',["jquery", "eventManager", "picturefill"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require("picturefill")) :
    console && console.error('Picture does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, picturefill) {

    function Picture(scope, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer) {
        ///<summary>Initialize a new instance of Picture. </summary>

        var self = this;
        Object.defineProperty(this, '$scope', { enumerable: true, value: $(scope) });
        Object.defineProperty(this, "stateChangeMessages", { enumerable: true, value: stateChangeMessages.slice() });

        //#region show messages performer
        if (onShowMessagesPerformer.length) {
            onShowMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.show, self);
            });

        }
        //#endregion


        //#region hide mesage performer
        if (onHideMessagePerformer.length) {
            onHideMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.hide, self);
            });
        }
        //#endregion

        picturefill({ context: this.$scope.get(0) });
    }

    Picture.prototype.show = function () {
        ///<summary>Make panel visible with jQuery.show() method.</summary>
        this.$scope.show();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Picture.prototype.hide = function () {
        ///<summary>Make panel hidden with jQuery.hide() method.</summary>
        this.$scope.hide();

        var self = this;
        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Picture.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new Picture(args.scope,
                args.StateChangeMessagesTransmitting || [],
                args.ShowActionMessages || [],
                args.HideActionMessages || []);
    };

    return Picture;
}));
